import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { IsShowDetail, IsShowReg, RiaBottomState } from "../../recoil/states";
import { asyncReqCommunityBoardList, CommunityBoardListActions } from "../../reducers/CommunityBoardListReducer";
import { TopSearchActions } from "../../reducers/TopSearchReducer";
import { AppDispatch } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";
import BoardDetail from "./BoardDetail";
import BoardList from "./BoardList";
import BoardReg from "./BoardReg";
import TopBtns from "./TopBtns";

const Index = () => {
  const setRiaBottomState = useSetRecoilState(RiaBottomState); // 하단 UI 랜더링 처리를 위해 사용되는 state
  const dispatch = useDispatch<AppDispatch>();

  const isShowReg = useRecoilValue(IsShowReg); // 등록 UI 표시 여부
  const isShowDetail = useRecoilValue(IsShowDetail); // 상세 UI 표시 여부

  useEffect(() => {
    dispatch(TopSearchActions.setInputValSearch("")); // 상단 검색어 키워드 문자열 삭제
    setRiaBottomState(rawState => ({ ...rawState, currPathName: window.location.pathname })); // 이전/다음 손가락 버튼 숨김 요청

    // 게시물 목록 가져오기
    const page_size = parseInt(process.env.REACT_APP_COMMUNITY_BOARD_PAGE_SIZE as string, 10);
    const curr_page = parseInt(CommonUtil.getQuerystring("curr_page", "1"), 10);
    const search_type = CommonUtil.getQuerystring("search_type", "");
    const search_keyword = CommonUtil.getQuerystring("search_keyword", "");
    const sub_menu = CommonUtil.getQuerystring("sub_menu", "");
    dispatch(asyncReqCommunityBoardList({ page_size, curr_page, search_type, search_keyword, sub_menu }));
    dispatch(CommunityBoardListActions.setCurrPage(curr_page)); // 현재 페이지 번호 저장
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div id="div_sub_title_ui" className="bo_list" style={{ textAlign: "center" }}>
        <h2 className="cnt_title" style={{ display: "inline-block", width: "100%" }}>커뮤니티 게시판</h2>
      </div>
      {
        isShowReg ?
          <>
            {/* <!-- 게시물 등록 UI 영역 (시작) --> */}
            <BoardReg />
            {/* <!-- 게시물 등록 UI 영역 (끝) --> */}
          </>
          :
          <>
            {
              isShowDetail &&
              <>
                {/* <!-- 게시물 상세 정보 UI 영역 (시작) --> */}
                < BoardDetail />
                {/* <!-- 게시물 상세 정보 UI 영역 (끝) --> */}
              </>
            }
            {/* <!-- '전체 / 일간 / 주간 / 월간' 버튼 UI 영역 (시작) --> */}
            <TopBtns />
            {/* <!-- '전체 / 일간 / 주간 / 월간' 버튼 UI 영역 (끝) --> */}

            {/* <!-- 게시물 목록 UI 영역 (시작) --> */}
            <BoardList />
            {/* <!-- 게시물 목록 UI 영역 (끝) --> */}
            {
              CommonUtil.isMobileOs() &&
              <div style={{ height: "200px" }}>&nbsp;</div> // 앱 내에서 검색어 입력 시, 관련 UI를 키패드가 가려버림.. 하단에 여유공간 확보!
            }
          </>
      }
    </>
  )
}

export default Index;
